import { parseId } from './postingModule';
import uuidv4 from '~/utils/uuidv4';

const candidateTemplate = (data = {}) => ({
    id: data.id,

    cv: data.cv,
    degrees: data && data.degrees ? data.degrees.map(degreeTemplate) : [],

    studyPrograms: data && data.studyPrograms ? data.studyPrograms : [],

    languages: data && data.languages ? data.languages.map(languageTemplate) : [],

    linkedin: data.linkedin,
    github: data.github,

    skills: data && data.skills ? data.skills : [], // TODO: Make proper template
    interests: data && data.interests ? data.interests : [], // TODO: Make proper template
    tests: data && data.tests ? data.tests : [], // TODO: Make proper template
    nationalities: data && data.nationalities ? data.nationalities : [], // TODO: Make proper template

    summary: data.summary,

    pronoun: data.pronoun,
    links: data.links,
    ethnicMinority: data.ethnicMinority,
    disability: data.disability,
    country: data.country,
});

const degreeTemplate = (data = {}) => ({
    id: data.id,
    candidate_id: data.candidate_id,
    created_at: data.created_at,

    campusId: data.campusId,

    school_id: data.school_id,
    school: data && data.school ? schoolTemplate(data.school) : undefined,

    field_id: data.field_id,
    level_id: data.level_id,
    field: data.field,
    level: data.level,

    name: data.name,
    description: data.description,
    documents: data.documents || [],

    start: data.start,
    end: data.end,
});

const languageTemplate = (data = {}) => ({
    id: data.id,
    created_at: data.created_at,
    candidate_id: data.candidate_id,
    languageId: data.language && data.language.id,
    language: data.language && data.language.name,
    proficiencyId: data.proficiency && data.proficiency.id,
    proficiency: data.proficiency && data.proficiency.level,
});

const schoolTemplate = (data = {}) => ({
    id: data.id,
    created_at: data.created_at,
    logo: data.logo,
    name: data.name,
});

const languageInfoTemplate = (data = {}) => ({
    languages:
        data.languages instanceof Array
            ? data.languages.map(lang => ({ id: lang.id, name: lang.name }))
            : [],
    proficiencies:
        data.proficiencies instanceof Array
            ? data.proficiencies.map(prof => ({
                  id: prof.id,
                  level: prof.level,
              }))
            : [],
});

export const favoriteTemplate = (data = {}) => {
    const favorite = {
        id: data.id,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
        postingExpireTime: data.postingExpireTime,

        candidateId: data.candidate_id,
        jobAdId: data.jobAdId,
    };

    if (data.job) {
        favorite.job = {
            id: parseId(data.job.jobName),
            jobAdId: data.job.jobId,
            title: data.job.title,
            companyId: data.job.companyId,
            companyLogo: data.job.companyLogo,
            companyName: data.job.companyName,
            deadline: data.job.postingExpireTime,
            address: data.job.address,
        };
    }
    return favorite;
};

const profileSharingConsentTemplate = (data = {}) => ({
    ...data,
    id: data.id,
    createdAt: data.created_at,
    updatedAt: data.updated_at,

    userId: data.user_id,
    sharedWithUser: data.sharedWithUser,
    sharedWithOrg: data.sharedWithOrg,
    consented: data.consented,
    consentedAt: data.consentedAt,
    expirationTime: data.expirationTime,
});

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: ['CANDIDATE_TEMPLATE', candidateTemplate],
    authorize: true,

    '/me': {
        GET: {},
        PUT: {},
    },

    '/cv': {
        template: ['CV_TEMPLATE', data => data],
        '/list': {
            GET: {},
        },
        '/create': {
            POST: {},
        },
        '/delete': {
            '/:id': {
                DELETE: {},
            },
        },
        '/setdefault': {
            '/:id': {
                POST: {},
            },
        },
    },

    '/language': {
        template: ['LANGUAGE_TEMPLATE', languageTemplate],
        POST: {},

        '/:id': {
            PUT: {},
            DELETE: {},
        },
    },

    // Get all available languages and proficiencies in the system
    '/languages': {
        template: ['LANGUAGES_TEMPLATE', languageInfoTemplate],
        GET: {},
    },

    '/degree': {
        template: ['DEGREE_TEMPLATE', degreeTemplate],
        POST: {},

        '/:id': {
            PUT: {},
            DELETE: {},
        },
    },

    '/school': {
        template: ['SCHOOL_TEMPLATE', schoolTemplate],
        POST: {},
        GET: {},
    },

    '/favorite': {
        template: ['FAVORITE_TEMPLATE', data => ({ id: 1, ...data })],
        authorize: true,
        POST: {},
        GET: {},

        '/:id': {
            template: ['FAVORITE_TEMPLATE', favoriteTemplate],
            DELETE: {},
            GET: {},
        },
    },

    '/workauthorization': {
        template: [
            'WORKAUTHORIZATION_TEMPLATE',
            data => ({
                id: data.id ? data.id : uuidv4(),
                code: data.code,
                implicit: data.implicit,
                type: data.type,
            }),
        ],
        GET: {},
        POST: {},
        '/:id': {
            DELETE: {},
        },
    },

    '/share': {
        template: ['PROFILE_SHARING_TEMPLATE', profileSharingConsentTemplate],
        POST: {},
        PUT: {},
        GET: {
            template: [
                'PROFILE_SHARING_TEMPLATE_GET',
                (data = {}) => ({
                    count: data.count,
                    data: (data.data || []).map(profileSharingConsentTemplate),
                }),
            ],
        },
        '/:userId': {
            GET: {},
        },
    },
};
